module.exports = __webpack_public_path__ + "static/img/30.73c73b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mohu/3/30.png
// module id = Xgo2
// module chunks = 0